<template>
  <transition name="shimmer-fade">
    <div v-if="show" class="shimmer-loader-overlay">
      <div class="shimmer-loader-content">
        <!-- List/Table Layout -->
        <template v-if="layoutType === 'list'">
          <div class="shimmer-header">
            <div class="shimmer-line shimmer-line-title"></div>
            <div class="shimmer-line shimmer-line-subtitle"></div>
          </div>
          <div class="shimmer-table-container">
            <div class="shimmer-table-header">
              <div class="shimmer-table-header-cell" v-for="n in 5" :key="n"></div>
            </div>
            <div 
              class="shimmer-table-row" 
              v-for="n in 6" 
              :key="n"
              :style="{ animationDelay: `${n * 0.1}s` }"
            >
              <div class="shimmer-table-cell" v-for="m in 5" :key="m"></div>
            </div>
          </div>
        </template>

        <!-- Dashboard/Overview Layout -->
        <template v-else-if="layoutType === 'dashboard'">
          <div class="shimmer-header">
            <div class="shimmer-line shimmer-line-title"></div>
          </div>
          <div class="shimmer-dashboard-grid">
            <div class="shimmer-stat-card" v-for="n in 4" :key="n">
              <div class="shimmer-line shimmer-line-small"></div>
              <div class="shimmer-line shimmer-line-large"></div>
            </div>
          </div>
          <div class="shimmer-chart-container">
            <div class="shimmer-line shimmer-line-title"></div>
            <div class="shimmer-chart"></div>
          </div>
        </template>

        <!-- Form/Detail Layout -->
        <template v-else-if="layoutType === 'form'">
          <div class="shimmer-header">
            <div class="shimmer-line shimmer-line-title"></div>
          </div>
          <div class="shimmer-form-container">
            <div class="shimmer-form-section" v-for="n in 3" :key="n">
              <div class="shimmer-line shimmer-line-medium"></div>
              <div class="shimmer-form-row" v-for="m in 2" :key="m">
                <div class="shimmer-form-field">
                  <div class="shimmer-line shimmer-line-small"></div>
                  <div class="shimmer-input"></div>
                </div>
                <div class="shimmer-form-field">
                  <div class="shimmer-line shimmer-line-small"></div>
                  <div class="shimmer-input"></div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Card/Grid Layout (Default) -->
        <template v-else>
          <div class="shimmer-header">
            <div class="shimmer-line shimmer-line-title"></div>
            <div class="shimmer-line shimmer-line-subtitle"></div>
          </div>
          <div class="shimmer-body">
            <div class="shimmer-card" v-for="n in 3" :key="n">
              <div class="shimmer-avatar"></div>
              <div class="shimmer-card-content">
                <div class="shimmer-line shimmer-line-medium"></div>
                <div class="shimmer-line shimmer-line-small"></div>
                <div class="shimmer-line shimmer-line-small"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import './ShimmerLoader.css';

export default {
  name: 'ShimmerLoader',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    route: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    layoutType() {
      if (!this.route || !this.route.path) return 'card';
      
      const path = this.route.path.toLowerCase();
      const name = this.route.name ? this.route.name.toLowerCase() : '';
      
      // List/Table pages
      if (path.includes('/list') || 
          path.includes('/invoices') || 
          path.includes('/customers/list') ||
          path.includes('/vendors/list') ||
          path.includes('/items') ||
          name.includes('list')) {
        return 'list';
      }
      
      // Dashboard/Overview pages
      if (path.includes('/overview') || 
          path.includes('/dashboard') ||
          name.includes('overview') ||
          name.includes('dashboard')) {
        return 'dashboard';
      }
      
      // Form/Detail pages
      if (path.includes('/new') || 
          path.includes('/edit') || 
          path.includes('/create') ||
          path.includes('/add') ||
          name.includes('new') ||
          name.includes('edit') ||
          name.includes('create') ||
          name.includes('add')) {
        return 'form';
      }
      
      // Default card layout
      return 'card';
    }
  }
}
</script>

